import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import localize from "@/utils/localization";
import { orList } from "@/utils/strings";
import HelpText from "@/components/Help/HelpText.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreatorShowExtensions',
    props: {
        extensions: null,
        upload: { type: Boolean }
    },
    setup(__props) {
        return { __sfc: true, BAlert, localize, orList, HelpText };
    }
});
